import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Combobox, ComboboxItem, Input } from '@node-space/ui-components'
import { AddBeneficiaryFormErrors, BaseFormProps } from 'types/beneficiaries'

interface ZarFormFieldsProps extends BaseFormProps {
  routingNumberBranchCode: string
  selectedBank: string
  bankOptions?: ComboboxItem[]
  accountNumber: string
  accountType: string
  errors: AddBeneficiaryFormErrors
  isFetchingBanks: boolean
  setValue: (name: string, value: string) => void
}

export const ZarFormFields = ({
  routingNumberBranchCode,
  accountNumber,
  accountType,
  selectedBank,
  bankOptions,
  errors,
  isFetchingBanks,
  handleChange,
  register,
  setValue,
}: ZarFormFieldsProps) => {
  const { t } = useTranslation()

  const accountTypeOptions = [
    {
      leftText: t('cheque'),
      value: 'CHEQUE',
    },
    {
      leftText: t('savings'),
      value: 'SAVINGS',
    },
    {
      leftText: t('transmission'),
      value: 'TRANSMISSION',
    },
  ]

  const handleBankOnChange = (bankCode: string) => {
    handleChange('zarBank', bankCode)
    const bankName = bankOptions?.find(bank => bank?.value === bankCode)?.leftText
    if (bankName) {
      handleChange('bankName', bankName as string)
    }
  }

  return (
    <>
      <Box flexSize="fill" paddingB={16}>
        <Combobox
          {...register('zarBank')}
          label={t('bank')}
          id="bank"
          items={bankOptions}
          onChange={value => handleBankOnChange(value)}
          errorText={errors?.zarBank?.message}
          loading={isFetchingBanks}
          defaultValue={selectedBank}
        />
      </Box>
      <Box paddingB={16}>
        <Input
          {...register('zarAccountNumber')}
          label={t('accountNumber')}
          placeholder={t('enterAccountNumber')}
          inputMode="numeric"
          name="zarAccountNumber"
          test-id="input-zar-account-number"
          errorText={errors?.zarAccountNumber?.message}
          error={!!errors?.zarAccountNumber}
          value={accountNumber}
          onChange={event => handleChange('zarAccountNumber', event?.target?.value)}
        />
      </Box>
      <Box paddingB={16}>
        <Input
          {...register('zarRoutingNumberBranchCode')}
          label={t('manageBeneficiaries.abaRoutingCode')}
          placeholder={t('enterCode')}
          inputMode="numeric"
          name="zarRoutingNumberBranchCode"
          test-id="input-zar-routing-number"
          errorText={errors?.zarRoutingNumberBranchCode?.message}
          error={!!errors?.zarRoutingNumberBranchCode}
          value={routingNumberBranchCode}
          onChange={event => handleChange('zarRoutingNumberBranchCode', event?.target?.value)}
        />
      </Box>
      <Box flexSize="fill" paddingB={16}>
        <Combobox
          {...register('zarAccountType')}
          label={t('accountType')}
          id="account-type"
          items={accountTypeOptions}
          onChange={value => setValue('zarAccountType', value)}
          errorText={errors?.zarAccountType?.message}
          defaultValue={accountType}
        />
      </Box>
    </>
  )
}
